import { create } from 'zustand'

import type { ApiEnvelope } from '@/shared/api/repositories/http-repositories'
import { request } from '@/utils/http/client'


interface BackendRuntimeConfig {
  schema_version: number
  version: number
  api_base_url: string
  web_base_url: string
  allow_insecure_http: boolean
  allow_insecure_http_until: string | null
  updated_at: string
}

interface RuntimeConfigState {
  apiBaseUrl: string
  webBaseUrl: string
  allowInsecureHttp: boolean
  version: number | null
  hydrated: boolean
  error: string | null
  bootstrap: () => Promise<void>
}

const browserOrigin = () =>
  typeof window === 'undefined' ? '' : window.location.origin.replace(/\/$/, '')

let bootstrapPromise: Promise<void> | null = null

export const useRuntimeConfigStore = create<RuntimeConfigState>((set, get) => ({
  apiBaseUrl: '/api/v1',
  webBaseUrl: browserOrigin(),
  allowInsecureHttp: false,
  version: null,
  hydrated: false,
  error: null,
  bootstrap: () => {
    if (get().hydrated) return Promise.resolve()
    bootstrapPromise ??= request<ApiEnvelope<BackendRuntimeConfig>>({
      method: 'GET',
      url: '/public/runtime-config',
      skipAuth: true,
      skipRefresh: true,
    })
      .then(({ data }) => {
        set({
          apiBaseUrl: data.api_base_url,
          webBaseUrl: data.web_base_url.replace(/\/$/, ''),
          allowInsecureHttp: data.allow_insecure_http,
          version: data.version,
          hydrated: true,
          error: null,
        })
      })
      .catch((reason: unknown) => {
        set({
          webBaseUrl: browserOrigin(),
          hydrated: true,
          error: reason instanceof Error ? reason.message : '运行配置读取失败',
        })
      })
      .finally(() => {
        bootstrapPromise = null
      })
    return bootstrapPromise
  },
}))

